module.exports = __webpack_public_path__ + "img/icon-check.fed775a9.svg";